import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { getObjectUrl } from 'utils/mediaUtils'
import ImagesViewer from 'components/common/ImagesViewer'

const useStyles = makeStyles(theme => ({
  image: {
    width: 118,
    height: 80,
    borderRadius: 10,
    marginRight: 16,
    cursor: 'pointer'
  }
}))

const ImageAttachment = ({ s3Object }) => {
  const classes = useStyles()

  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false)

  return (
    <>
      <img src={getObjectUrl(s3Object)} alt="" className={classes.image} onClick={() => setIsImageViewerOpen(true)} />
      <ImagesViewer
        isVisible={isImageViewerOpen}
        onClose={() => setIsImageViewerOpen(false)}
        imageS3Objects={[s3Object]}
      />
    </>
  )
}

export default ImageAttachment
